import _ from "lodash"
import React from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Typeahead from "components/Typeahead"
import NumberField from "components/NumberField"
import ReactSelect from "components/ReactSelect"
import { loadingStatus, getPayload } from "actions"
import { render } from "react-dom"


class KeyValueField extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			data: {},
			store: [], // internal to this component
		}
	}

	componentDidMount() {
		this.buildData()
	}

	componentDidUpdate(prevProps) {
		if (!_.isEqual(this.props, prevProps)) {
			this.buildData()
		}
	}

	buildData = () => {
		let ret = []
		_.forEach(this.props.data, (v, k) => {
			ret.push({ key: parseInt(k) ? parseInt(k) : k, value: v })
		})

		this.setState({ store: ret })
	}

	buildFinalResponse = () => {
		let ret = {}
		_.forEach(this.state.store, (v) => {
			_.setWith(ret, `${v.key}`, v.value, Object)
		})
		this.props.onChange(ret)
	}

	handleValueChange = (v, k) => {
		let store = _.clone(this.state.store)
		store[k].value = parseInt(v) ? parseInt(v) : v
		this.setState({ store }, () => {
			this.buildFinalResponse()
		})
		//this.props.onChange(this.props.name, value.target.value)
	}

	handleKeyChange = (v, k) => {
		let store = _.clone(this.state.store)
		store[k].key = parseInt(v) ? parseInt(v) : v
		this.setState({ store }, () => {
			this.buildFinalResponse()
		})
	}

	addRow = () => {
		let store = _.clone(this.state.store)
		store.push({ key: null, value: null })
		this.setState({ store })
	}

	buildHeaders = () => {
		let ret = []
		ret.push(<th key={`Header-${this.props.options.key.header}`}>{this.props.options.key.header}</th>)
		ret.push(<th key={`Val-${this.props.options.key.header}`}>{this.props.options.value.header}</th>)
		if(this.props.delete) ret.push(<th key={`Delete-${this.props.options.key.header}`}></th>)
		return ret
	}

	removeRow = (k) => {
		let store = _.clone(this.state.store)
		store.splice(k, 1)
		this.setState({ store }, () => {
			this.buildFinalResponse()
		})
	}

	buildRows = () => {
		let ret = []
		_.forEach(this.state.store, (v, k) => {
			let key
			let value
			if (_.get(this.props, `options.key.type`) === "typeahead") {
				let id = parseInt(this.state.store[k].key)
				let placeholderLookup = _.find(this.props.payload.public[this.props.options.key.lookup], { id })
				let placeholder = ""
				if (placeholderLookup) placeholder = placeholderLookup.name
				key = (
					<Typeahead
						name={`name-${this.state.store[k].key}`}
						className="form__input"
						value={this.state.store[k].key}
						onChange={(old, v) => this.handleKeyChange(v, k)}
						placeholder={placeholder}
						dataset={this.props.payload.public.properties}
						onBlur={() => {}}
					/>
				)
			}
			if (_.get(this.props, `options.key.type`) === "select") {
				key = (
					<ReactSelect
						name={`builder-${k}`}
						options={_.map(this.props.payload.public[this.props.options.key.lookup], (v) => {
							return {
								label: v.name,
								value: v.id,
							}
						})}
						value={this.state.store[k].key}
						onBlur={() => {}}
						onChange={(old, v) => this.handleKeyChange(v, k)}
					/>
				)
			}
			if (_.get(this.props, `options.value.type`) === "number") {
				value = (
					<NumberField
						name={this.state.store[k].value}
						value={this.state.store[k].value}
						type="text"
						className="form__input"
						onChange={(old, v) => this.handleValueChange(v, k)}
						thousandSeparator={true}
						numeric={true}
						onBlur={() => {}}
					/>
				)
			}
			ret.push(
				<tr key={k}>
					<td style={{ paddingRight: 20 }}>{key}</td>
					<td>{value}</td>
					{this.props.delete ? (
						<td>
							<i
								className="fa fa-minus-circle cursor-pointer"
								onClick={() => {
									this.removeRow(k)
								}}
							/>
						</td>
					) : null}
				</tr>
			)
		})
		return ret
	}

	render() {
		return (
			<div>
				<p className="traffic__addMore">
					<span
						onClick={() => {
							this.addRow()
						}}>
						<i className="fa fa-plus-circle" />
					</span>
				</p>
				<table className="inputTable">
					<thead>
						<tr>{this.buildHeaders()}</tr>
					</thead>
					<tbody>{this.buildRows()}</tbody>
				</table>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(KeyValueField)
